module.exports = __webpack_public_path__ + "static/img/l_13.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/l_13.png
// module id = VjfC
// module chunks = 1